import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import PostcodeQuotenewCoach from "./PostcodeQuotenewCoach";
import ReviewsBar from "../components/ReviewsBar";
import LiveStrip from "../components/LiveStrip";
import "./Home.css";
import "../styles/minibus-hire.css";

const CoachHire = () => {
  const scrollToForm = () => {
    const el = document.getElementById("coach-quote-form");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="minibus-page">
      {/* 🔍 SEO + Schema */}
      <Helmet>
        <title>
          Coach Hire – 25+  Seater Group Travel to Heathrow & London | CheapCabGrab
        </title>
        <meta
          name="description"
          content="Book 25+ seater minibuses for Heathrow, Gatwick, Luton, Stansted and London. Fixed-price group transfers, licensed drivers and trusted PSV partners with CheapCabGrab."
        />
        <link rel="canonical" href="https://www.cheapcabgrab.com/minibus-hire" />
        <meta
          name="keywords"
          content="minibus hire, Heathrow minibus, Gatwick minibus, 9 seater minibus, 14 seater minibus, group airport transfers, CheapCabGrab"
        />

        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Coach Hire – 25+ Seater Group Travel to Heathrow & London"
        />
        <meta
          property="og:description"
          content="Reliable minibus hire for Heathrow, Gatwick, Luton, Stansted and London. 25+ seater vehicles, luggage space, airport specialists and fixed quotes."
        />
        <meta property="og:url" content="https://www.cheapcabgrab.com/minibus-hire" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "TaxiService",
            name: "CheapCabGrab – Coach Hire",
            url: "https://www.cheapcabgrab.com/minibus-hire",
            areaServed: [
              "Heathrow Airport",
              "Gatwick Airport",
              "Luton Airport",
              "Stansted Airport",
              "London",
              "Slough",
              "Windsor",
              "Maidenhead"
            ],
            serviceArea: {
              "@type": "Place",
              name: "Heathrow, London airports and surrounding areas"
            },
            provider: {
              "@type": "Organization",
              name: "CheapCabGrab Ltd"
            }
          })}
        </script>
      </Helmet>

      <LiveStrip variant="heathrow" />

      {/* 🟦 HERO */}
      <section className="home-hero">
        <div className="home-hero-shell">
          <div className="home-hero-copy">
            <h1>Coach Hire for Heathrow, London & UK Trips</h1>
            <p>25–53 seater group travel specialists</p>
            <p>
              Book reliable coaches for airports, events and UK tours. Fixed-price quotes,
              licensed PSV partners and roomy luggage space for teams, schools and large groups.
            </p>
          </div>

          <div className="home-hero-form-row" id="coach-quote-form">
            <PostcodeQuotenewCoach />
          </div>

          <ul className="home-hero-flags">
            <li>✅ Heathrow, Gatwick, Luton, Stansted & London coverage</li>
            <li>✅ 25–53 seater coaches for teams, schools & events</li>
            <li>✅ Fixed upfront quotes — no surge pricing</li>
            <li>✔ Licensed PSV operators ✔ Professional drivers ✔ Luggage-ready</li>
          </ul>

          <div className="home-hero-reviews">
            <ReviewsBar pageKey="/minibus-hire" count={3} />
          </div>
        </div>
      </section>

      {/* Floating CTA (desktop) */}
      <button className="home-floating-cta" onClick={scrollToForm}>
        🚐 Book Coach Hire
      </button>

      {/* 🟨 WHY CHEAPCABGRAB FOR MINIBUSES */}
      <section className="minibus-section" id="why-minibus">
        <header className="minibus-section-header">
          <h2>Why Choose CheapCabGrab for Coach Hire?</h2>
          <p>
            A simple, professional minibus service for airport transfers, London trips and
            group travel.
          </p>
        </header>

        <div className="minibus-grid-3">
          <article className="minibus-card">
            <h3>Airport Specialists</h3>
            <p>
              We handle Heathrow, Gatwick, Luton and Stansted transfers every day – ideal
              for families, tour groups, crew travel and business teams.
            </p>
          </article>

          <article className="minibus-card">
            <h3>Fixed, Upfront Pricing</h3>
            <p>
              No surge pricing, no meter shock. You see your fare before you confirm – our
              system calculates the route and vehicle needed for your group.
            </p>
          </article>

          <article className="minibus-card">
            <h3>Licensed & Insured</h3>
            <p>
              Vehicles are fully licensed and insured for passenger transport. All drivers
              are vetted, experienced and used to early mornings and late-night flights.
            </p>
          </article>
        </div>
      </section>

      {/* 🚐 MINIBUS FLEET */}


{/* 🚌 COACH FLEET (25+ Seaters) */}
<section className="minibus-section" id="minibus-fleet">
  <header className="minibus-section-header">
    <h2>Our Coach Fleet – 25+ Seater Options</h2>
    <p>
      Comfortable, spacious coaches ideal for corporate travel, school trips, airport 
      transfers, UK tours and large group events. Fully licensed & operated by our
      trusted partner RHP Minibus Hire UK Ltd.
    </p>
  </header>

  <div className="minibus-fleet-grid">

    {/* 25 Seater Coach */}
    <article className="minibus-fleet-card">
      <h3>25 Seater Coach</h3>
      <ul>
        <li>👥 Up to 25 passengers</li>
        <li>🧳 Large underfloor luggage storage</li>
        <li>Comfortable seats + overhead storage</li>
        <li>Ideal for corporate outings, UK sightseeing & airport transfers</li>
        <li>Perfect for Heathrow, Gatwick, Luton & London venues</li>
      </ul>
    </article>

    {/* 33–35 Seater Coach */}
    <article className="minibus-fleet-card">
      <h3>33–35 Seater Coach</h3>
      <ul>
        <li>👥 Mid-size coach for medium groups</li>
        <li>🧳 Spacious luggage bay + overhead shelves</li>
        <li>Comfort A/C, high seating position, PA system</li>
        <li>Best for school trips, sports teams, weddings & tours</li>
      </ul>
    </article>

    {/* 49–53 Seater Executive Coach */}
    <article className="minibus-fleet-card">
      <h3>49–53 Seater Executive Coach</h3>
      <ul>
        <li>👥 Up to 53 passengers</li>
        <li>🧳 Large underfloor luggage bays</li>
        <li>Reclining seats, A/C, WC on selected coaches</li>
        <li>Ideal for long-distance UK tours & event shuttles</li>
        <li>Perfect for airports, hotels, exhibitions & conferences</li>
      </ul>
    </article>

  </div>

  <p className="minibus-fleet-note">
    For VIP coaches or specialist requirements, submit a quote and our partner{" "}
    <strong>RHP Minibus Hire UK Ltd</strong> will match you with the ideal vehicle.
  </p>
</section>




{/* 🚌 COACH FLEET (25+ Seaters) */}
<section className="minibus-section" id="minibus-fleet">
  <header className="minibus-section-header">
    <h2>Our Coach Fleet – 25+ Seater Options</h2>
    <p>
      Comfortable, spacious coaches ideal for corporate travel, school trips, airport 
      transfers, UK tours and large group events. Fully licensed & operated by our
      trusted partner RHP Minibus Hire UK Ltd.
    </p>
  </header>

  <div className="minibus-fleet-grid">

    {/* 25 Seater Coach */}
    <article className="minibus-fleet-card">
      <h3>25 Seater Coach</h3>
      <ul>
        <li>👥 Up to 25 passengers</li>
        <li>🧳 Large underfloor luggage storage</li>
        <li>Comfortable seats + overhead storage</li>
        <li>Ideal for corporate outings, UK sightseeing & airport transfers</li>
        <li>Perfect for Heathrow, Gatwick, Luton & London venues</li>
      </ul>
    </article>

    {/* 33–35 Seater Coach */}
    <article className="minibus-fleet-card">
      <h3>33–35 Seater Coach</h3>
      <ul>
        <li>👥 Mid-size coach for medium groups</li>
        <li>🧳 Spacious luggage bay + overhead shelves</li>
        <li>Comfort A/C, high seating position, PA system</li>
        <li>Best for school trips, sports teams, weddings & tours</li>
      </ul>
    </article>

    {/* 49–53 Seater Executive Coach */}
    <article className="minibus-fleet-card">
      <h3>49–53 Seater Executive Coach</h3>
      <ul>
        <li>👥 Up to 53 passengers</li>
        <li>🧳 Large underfloor luggage bays</li>
        <li>Reclining seats, A/C, WC on selected coaches</li>
        <li>Ideal for long-distance UK tours & event shuttles</li>
        <li>Perfect for airports, hotels, exhibitions & conferences</li>
      </ul>
    </article>

  </div>

  <p className="minibus-fleet-note">
    For VIP coaches or specialist requirements, submit a quote and our partner{" "}
    <strong>RHP Minibus Hire UK Ltd</strong> will match you with the ideal vehicle.
  </p>
</section>

      {/* 🤝 PARTNER / COMPLIANCE NOTE */}
      <section className="minibus-section" id="minibus-partner">
        <header className="minibus-section-header">
          <h2>Licensed PSV Partner Coach Operations</h2>
          <p>
            Where a PSV licence is required, CheapCabGrab works with trusted partners to
            deliver safe, compliant group transport.
          </p>
        </header>

        <div className="minibus-partner-box">
          <p>
            CheapCabGrab is focused on making booking, pricing and customer support simple.
            For certain minibus and coach services, operations may be fulfilled by{" "}
            <strong>RHP MINIBUS HIRE UK LIMITED</strong> and other licensed PSV partners,
            ensuring vehicles and drivers meet all relevant UK regulations.
          </p>
          <p>
            You still book, pay and receive support through CheapCabGrab – we simply match
            you with the correct licensed operator for your journey.
          </p>
        </div>
      </section>

      {/* ❓ FAQ BLOCK */}
      <section className="minibus-section" id="minibus-faq">
        <header className="minibus-section-header">
          <h2>Coach Hire FAQs</h2>
          <p>Some common questions about booking a 25+  seater with CheapCabGrab.</p>
        </header>

        <div className="minibus-faq-grid">
          <article className="minibus-faq-card">
            <h3>How far in advance should we book?</h3>
            <p>
              For airports and busy weekends, we recommend booking as early as possible so
              we can guarantee the correct size minibus. Same-day requests may still be
              possible depending on availability.
            </p>
          </article>

          <article className="minibus-faq-card">
            <h3>Can we book multiple pickups?</h3>
            <p>
              Yes – just tell us in the notes when you request a quote, or contact{" "}
              <Link to="/contact">support</Link> for more complex multi-stop journeys or
              event shuttles.
            </p>
          </article>

          <article className="minibus-faq-card">
            <h3>Are child seats and booster seats available?</h3>
            <p>
              We can arrange child and booster seats when requested in advance. Please let
              us know the ages of children travelling so we can prepare correctly.
            </p>
          </article>

          <article className="minibus-faq-card">
            <h3>Do you offer meet & greet at airports?</h3>
            <p>
              Meet & greet is available as an optional extra for minibus bookings. Standard
              pickups are from pre-agreed collection points at the terminal or car park.
            </p>
          </article>

          <article className="minibus-faq-card">
            <h3>Can we use a minibus for corporate events?</h3>
            <p>
              Yes – minibus hire is ideal for moving teams between offices, hotels,
              stations and venues. For regular movements, our team can help plan routes and
              schedules.
            </p>
          </article>

          <article className="minibus-faq-card">
            <h3>Where can I find more information?</h3>
            <p>
              See our <Link to="/faq">full FAQ page</Link> or{" "}
              <Link to="/contact">contact us</Link> if you have a specific question about
              minibus hire.
            </p>
          </article>
        </div>
      </section>

      {/* 🔗 INTERNAL LINKS */}
      <section className="minibus-section" id="minibus-links">
        <header className="minibus-section-header">
          <h2>Useful Links</h2>
        </header>

        <ul className="minibus-links-list">
          <li>
            <Link to="/heathrow-minibus-hire">Heathrow Coach Hire</Link>
          </li>
          <li>
            <Link to="/coach">Coach Hire</Link>
          </li>
          <li>
            <Link to="/fleet">Our Vehicles</Link>
          </li>
          <li>
            <Link to="/our-drivers">Our Drivers</Link>
          </li>
          <li>
            <Link to="/heathrow-taxi">Heathrow Taxi Service</Link>
          </li>
          <li>
            <Link to="/slough-taxi">Slough Taxi</Link>
          </li>
          <li>
            <Link to="/windsor-taxi">Windsor Taxi</Link>
          </li>
          <li>
            <Link to="/maidenhead-taxi">Maidenhead Taxi</Link>
          </li>
          <li>
            <Link to="/terminalFinder">Terminal Finder</Link>
          </li>
          <li>
            <Link to="/airlineContacts">Airline Contacts</Link>
          </li>
        </ul>
      </section>

    </div>

  );
};

export default CoachHire;
